"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_i18next_1 = require("react-i18next");
const components_1 = require("@alcumus/components");
const ReportBasePage_1 = __importDefault(require("../BasePage/ReportBasePage"));
const dashboard_1 = require("../../../server/models/dashboard");
const look_1 = require("../../../server/models/look");
const ReportsRoute_1 = __importDefault(require("../../../routes/ReportsRoute"));
const EmptyLookState_1 = __importDefault(require("../EmptyState/EmptyLookState"));
const ReportsHomePage = ({ t, tReady }) => {
    const headers = [
        { id: 'icon', displayName: '' },
        { id: 'name', displayName: t('name') },
        { id: 'viewCount', displayName: t('views'), isNumeric: true },
        { id: 'createdBy', displayName: t('owner') },
        { id: 'folder', displayName: t('folder') },
        { id: 'contentFavoriteId', displayName: t('favorite') },
    ];
    const emptyState = (react_1.default.createElement(EmptyLookState_1.default, { showCreateButton: localStorage.getItem('user_is_editor') === 'true', t: t }));
    return (react_1.default.createElement(components_1.TranslateReady, { tReady: tReady },
        react_1.default.createElement(ReportBasePage_1.default, { title: ReportsRoute_1.default.friendlyName, getDashboardsFunction: () => (0, dashboard_1.searchDashboardsAndSync)({}), getLooksFunction: () => (0, look_1.searchLooksAndSync)({}), headers: headers, showViews: true, emptyState: emptyState })));
};
exports.default = (0, react_i18next_1.withTranslation)(['TableHeaders', 'EmptyState', 'translation'])(ReportsHomePage);
